import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        ...mapState(stores.Mumber, ['number', 'numberVendor']),

        needsFormatter() {
            if (this.contact) {
                return this.contact.country !== 'GB' && this.contact.country !== 'AU';
            }

            return this.numberCountry !== 'GB' && this.numberCountry !== 'AU';
        },

        numberCountry() {
            if (!this.number) {
                return null;
            }

            return this.number.country;
        },
    },
};
